import "@maplibre/maplibre-gl-leaflet";

import { useEffect } from "react";
import PropTypes from "prop-types";
import L from "leaflet";
import { useMap } from "react-leaflet";
import { useI18n } from "../../spages/spa/context/I18nContext";
import getWFCONFIG from "../../utils/WF_CONFIG";
import MaplibreOmtLang from "./maplibre-omt-lang";

const WF_CONFIG = getWFCONFIG();

const propTypes = {
  mapTilerKey: PropTypes.string,
  attribution: PropTypes.string,
};

const MapLibreGLLayer = ({
  mapTilerKey = WF_CONFIG.MAP_TILER_KEY,
  attribution = "<a href='https://www.maptiler.com/copyright/' target='_blank'>© MapTiler</a> <a href='https://www.openstreetmap.org/copyright' target='_blank'>© OpenStreetMap contributors</a>",
  ...props
}) => {
  const updatedProps = { attribution, ...props };
  const map = useMap();
  const { lang } = useI18n();

  useEffect(() => {
    const style = `https://api.maptiler.com/maps/ec67300e-8535-4ef0-a92e-8b51034e12bb/style.json?key=${mapTilerKey}`;
    const layer = L.maplibreGL({ style, ...updatedProps });
    layer.addTo(map);

    const mapLang = new MaplibreOmtLang(lang);
    const mapLangControl = layer.getMaplibreMap();
    mapLangControl?.addControl(mapLang);

    return () => layer.remove();
    // We don't need to re-render when other props change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapTilerKey, lang]);

  return null;
};

/*
 * Props are the options supported by Maplibre Map object
 * Find options here:https://maplibre.org/maplibre-gl-js-docs/api/map/
 */
MapLibreGLLayer.propTypes = propTypes;

export default MapLibreGLLayer;
